import {
    Box,
    Stack,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import PlatformDetails from "./sections/PlatformDetails";
import PlatformType from "./sections/PlatformType";
import EmailSetup from "./sections/EmailSetup";
import Storage from "./sections/Storage";
import PlatformLicense from "./sections/PlatformLicense";
import { useRef } from "react";
import InfoHoverTooltip from "../../Tooltips/InfoHover";
import DownloadIcon from '@mui/icons-material/Download';
import { getMethod } from "../../../services/apiService";


const PlatformTab = () => {

    const [activeTab, setActiveTab] = useState<"users" | "roles" | "platform">("platform");
    const [sections, setSections] = useState<any[]>(["Platform Details", "Platform Type", "Email Setup", "Storage", "Platform License"]);
    const [selectedSection, setSelectedSection] = useState<string | null>("Platform Details");
    const [platformTypeConfig, setPlatformTypeConfig] =  useState(null);

    useEffect(()=>{
        console.log("selectedSection", selectedSection)
    },[selectedSection])

    const platformSubmitRef = useRef<() => void>();
    const storageSubmitRef = useRef<(() => void) | null>(null);


    const renderRightContent = () => {
        switch (selectedSection) {
            case "Platform Details":
                return (
                    <PlatformDetails  
                        onPlatformTypeSetupConfigLoad={(config) => setPlatformTypeConfig(config)}
                    />
                );
            case "Platform Type":
                return <PlatformType config={platformTypeConfig}/>;
            case "Email Setup":
                return <EmailSetup/>;
            case "Storage":
                return (<Storage
                    onSubmitRequest={(submitFn) => {
                        storageSubmitRef.current = submitFn;
                    }}
                />
                );
            case "Platform License":
                return <PlatformLicense/>;
            default:
                return (
                    <Typography sx={{ color: "#8FA2A9" }}>
                        Select a section to view its content.
                    </Typography>
                );
        }
    };


    const handleSaveClick = () => {
        console.log("Save clicked, attempting to call submitForm");

        // Check if submitForm exists and then call it
        if (platformSubmitRef.current) {
            platformSubmitRef.current(); // Call submitForm to trigger Formik submission
        } else {
            console.log("platformSubmitRef.current is undefined!");
        }
    };


    const downloadLicenseKey = async () => {
        const resp = await getMethod(`platform/license/key`);
        if (resp?.status === 200) {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `platform.key`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <Box
            sx={{
                flexGrow: 1,
                p: 3,
                marginTop: 7,
                padding: 0,
            }}
        >
            <Box sx={{ margin: "20px" }} component="main" height={'100%'}>
                <Grid
                    container
                    spacing={2}
                    sx={{
                        // height: "calc(100vh - 150px)",
                        overflow: "hidden",
                        marginTop: 0,
                    }}
                >
                    {/* LEFT SIDE: your existing stacked grids */}
                    <Grid
                        size={4}
                        sx={{
                            overflowY: "scroll",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": { display: "none" },
                        }}
                    >
                        {sections?.map((type, index) => (
                            <Grid key={index} size={12}>
                                <Box
                                    onClick={() => setSelectedSection(type)}
                                    sx={{
                                        padding: "24px",
                                        borderRadius: "12px",
                                        marginBottom: "8px",
                                        cursor: "pointer",
                                        backgroundColor:
                                            selectedSection === type ? "#0B4A62" : "#1D292E",
                                        position: "relative",
                                        // width: "430px",
                                        // transition: "all 0.2s ease",
                                        // "&:hover": { backgroundColor: "#145E7B" },
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Stack direction="row" alignItems="center" gap="12px">
                                            <Typography
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: 600,
                                                    color: "#E2E3E3",
                                                    //   maxWidth: { xs: "200px", xl: "350px" },
                                                }}
                                                className="textEllipsis"
                                            >
                                                {type}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>

                    {/* RIGHT SIDE: dynamic content area */}
                    <Grid
                        size={8}
                        sx={{
                            // height: "calc(100vh - 70px)",
                            overflowY: "auto",
                            backgroundColor: "#1D292E",
                            borderRadius: "12px",
                            // p: 3,
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                backgroundColor: "#192529",
                                px: 3,
                                py: 2,
                                borderTopLeftRadius: "12px",
                                borderTopRightRadius: "12px",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "fit-content",
                                    fontWeight: 500,
                                    color: "#FFFFFF",
                                    fontSize: "16px",
                                }}
                            >
                                {selectedSection}
                            </Typography>

                            {selectedSection === "Platform License" && (
                                <InfoHoverTooltip title="Download license key" arrowDirection="bottom">
                                    <DownloadIcon
                                        sx={{
                                            color: "#17b2eb !important",
                                            fontSize: 24,
                                            stroke: "#17b2eb",
                                            fill: "#17b2eb",
                                            marginLeft: "10px",
                                            marginTop: "2px",
                                            width: "20px",
                                            height: "20px",
                                            cursor: "pointer",

                                        }}
                                    onClick={() => downloadLicenseKey()}
                                    />
                                </InfoHoverTooltip>
                            )}
                        </Box>
                        <Box sx={{ p: 3, padding: selectedSection === "Platform License" ? "0 3px 3px 3px" : 3}}>
                            {renderRightContent()}
                        </Box>
                       
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default PlatformTab;